import NavigationProvider, { useNavigationContext } from './NavigationProvider'

export default NavigationProvider
export { useNavigationContext }
